// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","StrollerBoxWidget":"ber_a bho_tr","StrollerBoxWidget__imageCounselling":"ber_b bho_kg"};